import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'countryFlag' })
export class CountryFlagPipe implements PipeTransform {
  transform(countryCode: string): string {
    if (!countryCode) return '';

    // Convert country code to regional indicator symbols
    const codePoints = countryCode
      .toUpperCase()
      .split('')
      .map((char) => 127397 + char.charCodeAt(0));

    return String.fromCodePoint(...codePoints);
  }
}
